import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"
import "./mobile_component.css"

export default class extends Controller {
  static targets = ["menu", "toggle", "caret"]

  connect() {
    useClickOutside(this, { element: this.element })
  }

  toggleMenu(event) {
    event?.preventDefault()

    if (!this.hasMenuTarget) return

    if (this.menuTarget.classList.contains("hidden")) {
      this.openMenu()
    } else {
      this.closeMenu()
    }
  }

  openMenu() {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.remove("hidden")

    // Trigger reflow for animation
    void this.menuTarget.offsetHeight

    this.menuTarget.classList.add("mobile-nav-menu-open")
    this.setExpandedState(true)
    this.rotateCaretDown()
  }

  closeMenu(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.hasMenuTarget) return

    this.menuTarget.classList.remove("mobile-nav-menu-open")
    this.setExpandedState(false)
    this.rotateCaretUp()

    // Wait for animation to complete before hiding
    setTimeout(() => {
      if (this.hasMenuTarget && !this.menuTarget.classList.contains("mobile-nav-menu-open")) {
        this.menuTarget.classList.add("hidden")
      }
    }, 200)
  }

  clickOutside(event) {
    if (!this.hasMenuTarget) return

    if (!this.menuTarget.classList.contains("hidden")) {
      this.closeMenu()
    }
  }

  handleEscape(event) {
    if (!this.hasMenuTarget) return

    if (!this.menuTarget.classList.contains("hidden")) {
      this.closeMenu()
    }
  }

  rotateCaretDown() {
    if (this.hasCaretTarget) {
      this.caretTarget.classList.add("mobile-nav-caret-open")
    }
  }

  rotateCaretUp() {
    if (this.hasCaretTarget) {
      this.caretTarget.classList.remove("mobile-nav-caret-open")
    }
  }

  setExpandedState(expanded) {
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", String(expanded))
    }
  }
}
